(function () {
  function showToast(root, message) {
    var toast = root.querySelector('[data-mc-toast]') || document.querySelector('[data-mc-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._hideTimer);
    toast._hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function readJsonResponse(response, fallbackMessage) {
    var contentType = response.headers.get('content-type') || '';
    var isJson = contentType.indexOf('json') !== -1;
    var payload = isJson
      ? response.json().catch(function () { return {}; })
      : Promise.resolve({});

    return payload.then(function (data) {
      if (!response.ok) {
        var message = data.description || data.message || fallbackMessage;
        if (response.status >= 500) message = 'Shopify is temporarily busy. Please try again.';
        throw new Error(message);
      }
      if (!isJson) throw new Error(fallbackMessage);
      return data;
    });
  }

  function updateCartCount(attempt) {
    attempt = attempt || 0;
    return fetch(window.Shopify.routes.root + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return readJsonResponse(response, 'Unable to refresh the cart.'); })
      .then(function (cart) {
        document.querySelectorAll('[data-mc-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count < 1;
        });
        return cart;
      })
      .catch(function (error) {
        if (attempt >= 2) throw error;
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 450 * (attempt + 1));
        }).then(function () { return updateCartCount(attempt + 1); });
      });
  }

  function stopPreview(card) {
    var video = card.querySelector('video');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (error) {}
    card.classList.remove('is-previewing');
    var label = card.querySelector('[data-mc-video-label]');
    if (label) label.textContent = 'Video preview';
  }

  function startPreview(card) {
    var video = card.querySelector('video');
    if (!video) return;
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
    var playPromise = video.play();
    if (!playPromise) return;
    playPromise.then(function () {
      card.classList.add('is-previewing');
      var label = card.querySelector('[data-mc-video-label]');
      if (label) label.textContent = 'Playing';
    }).catch(function () {});
  }

  function bindProductCards(root) {
    root.querySelectorAll('[data-mc-product-card]').forEach(function (card) {
      if (card.dataset.mcBound === 'true') return;
      card.dataset.mcBound = 'true';
      var trigger = card.querySelector('[data-mc-video-trigger]');
      var media = card.querySelector('.mc-product-media');
      var canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

      if (trigger && media) {
        if (canHover) {
          media.addEventListener('mouseenter', function () { startPreview(card); });
          media.addEventListener('mouseleave', function () { stopPreview(card); });
        }
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (card.classList.contains('is-previewing')) {
            stopPreview(card);
          } else {
            root.querySelectorAll('.mc-product-card.is-previewing').forEach(stopPreview);
            startPreview(card);
          }
        });
      }
    });
  }

  function bindTabs(root) {
    var tabs = root.querySelectorAll('[data-mc-category]');
    if (!tabs.length) return;
    function applyCategory(category, activeTab) {
      tabs.forEach(function (item) {
        var active = item === activeTab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      var panels = root.querySelectorAll('[data-mc-product-panel]');
      if (panels.length) {
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.mcProductPanel !== category;
          panel.setAttribute('aria-hidden', panel.hidden ? 'true' : 'false');
          if (panel.hidden) panel.querySelectorAll('.mc-product-card.is-previewing').forEach(stopPreview);
        });
      } else {
        root.querySelectorAll('[data-mc-product-card]').forEach(function (card) {
          card.hidden = category === 'recommended'
            ? card.dataset.recommended !== 'true'
            : card.dataset.category !== category;
          if (card.hidden) stopPreview(card);
        });
      }
    }
    tabs.forEach(function (tab) {
      if (tab.dataset.mcTabBound === 'true') return;
      tab.dataset.mcTabBound = 'true';
      tab.addEventListener('click', function () {
        applyCategory(tab.dataset.mcCategory, tab);
      });
    });
    var activeTab = root.querySelector('[data-mc-category].is-active') || tabs[0];
    applyCategory(activeTab.dataset.mcCategory, activeTab);
  }

  function bindAddForms(root) {
    root.querySelectorAll('[data-mc-add-form]').forEach(function (form) {
      if (form.dataset.mcBound === 'true') return;
      form.dataset.mcBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var quantityInput = form.querySelector('[name="quantity"]');
        var variantId = idInput ? Number(idInput.value) : 0;
        var quantity = quantityInput ? Number(quantityInput.value) : 1;
        quantity = Math.max(1, Math.min(999, Math.floor(quantity || 1)));
        var buyNow = event.submitter && event.submitter.hasAttribute('data-mc-buy-now');
        var button = event.submitter || form.querySelector('[type="submit"]');
        var original = button ? button.textContent : '';
        var submitStates = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]')).map(function (submitButton) {
          return { button: submitButton, disabled: submitButton.disabled };
        });

        if (!variantId) {
          showToast(root, 'Please select an available product option.');
          return;
        }

        submitStates.forEach(function (state) { state.button.disabled = true; });
        if (button) button.textContent = 'Adding...';
        var addItem = function () {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: quantity
              }]
            })
          }).then(function (response) { return readJsonResponse(response, 'Unable to add this item.'); });
        };
        var request = addItem();

        request
          .then(function () {
            showToast(root, 'Added to cart.');
            return updateCartCount().catch(function () {
              showToast(root, 'Item added. Open the cart to continue.');
            }).then(function () {
              if (buyNow) window.location.assign(window.Shopify.routes.root + 'checkout');
            });
          })
          .catch(function (error) {
            showToast(root, error.message || 'Unable to add this item.');
            if (button) button.textContent = original;
          })
          .finally(function () {
            window.setTimeout(function () {
              submitStates.forEach(function (state) { state.button.disabled = state.disabled; });
              if (button) button.textContent = original;
            }, 1100);
          });
      });
    });
  }

  function bindCartForm(root) {
    var form = root.querySelector('[data-mc-cart-form]');
    if (!form || form.dataset.mcBound === 'true') return;
    form.dataset.mcBound = 'true';
    var updateButton = form.querySelector('[data-mc-cart-update]');
    var checkoutButton = form.querySelector('[name="checkout"]');
    var timer;

    form.querySelectorAll('[data-mc-cart-quantity]').forEach(function (input) {
      input.addEventListener('change', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          if (updateButton) {
            updateButton.textContent = 'Updating...';
            updateButton.setAttribute('aria-disabled', 'true');
          }
          if (checkoutButton) checkoutButton.disabled = true;
          if (form.requestSubmit && updateButton) {
            form.requestSubmit(updateButton);
            updateButton.disabled = true;
          } else {
            form.submit();
          }
        }, 250);
      });
    });
  }

  function bindDetail(root) {
    var detail = root.querySelector('[data-mc-detail]');
    if (!detail || detail.dataset.mcBound === 'true') return;
    detail.dataset.mcBound = 'true';
    var quantity = detail.querySelector('[name="quantity"]');
    var variantSelect = detail.querySelector('select[name="id"]');
    var priceNode = detail.querySelector('[data-mc-current-price]');
    var currency = detail.dataset.currency || 'USD';

    function money(cents) {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    }

    function updateVariantPrice() {
      if (!variantSelect || !priceNode) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      var cents = Number(option.dataset.price || detail.dataset.basePrice || 0);
      priceNode.textContent = money(cents);
      detail.querySelectorAll('[data-tier-multiplier]').forEach(function (node) {
        node.textContent = money(Math.round(cents * Number(node.dataset.tierMultiplier)));
      });
    }

    detail.querySelectorAll('[data-mc-qty-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.mcQtyAction));
        quantity.value = next;
      });
    });
    detail.querySelectorAll('[data-mc-set-qty]').forEach(function (button) {
      button.addEventListener('click', function () { quantity.value = button.dataset.mcSetQty; });
    });
    if (variantSelect) variantSelect.addEventListener('change', updateVariantPrice);
    updateVariantPrice();

    var mainMedia = detail.querySelector('[data-mc-detail-main]');
    detail.querySelectorAll('[data-mc-media-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        var image = mainMedia.querySelector('img');
        var video = mainMedia.querySelector('video');
        if (image) {
          // Shopify image_tag outputs srcset; remove it so the selected image URL
          // is not immediately overridden by the browser's previous candidate.
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.mcMediaImage;
        }
        mainMedia.classList.remove('is-video');
        if (video) video.pause();
        detail.querySelectorAll('.mc-detail-thumb').forEach(function (item) { item.classList.toggle('is-active', item === button); });
      });
    });
    var videoButton = detail.querySelector('[data-mc-show-video]');
    if (videoButton) {
      videoButton.addEventListener('click', function () {
        var video = mainMedia.querySelector('video');
        if (!video) return;
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        video.play().then(function () { mainMedia.classList.add('is-video'); }).catch(function () {});
        detail.querySelectorAll('.mc-detail-thumb').forEach(function (item) { item.classList.toggle('is-active', item === videoButton); });
      });
    }
  }

  function init(root) {
    root.querySelectorAll('[data-mindify-shop]').forEach(function (shop) {
      if (shop.dataset.mcInit === 'true') return;
      shop.dataset.mcInit = 'true';
      bindTabs(shop);
      bindProductCards(shop);
      bindAddForms(shop);
      updateCartCount().catch(function () {});
    });
    bindAddForms(root);
    bindDetail(root);
    bindCartForm(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
